import React, { useCallback, useState, useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Form, Input } from "reactstrap";

const ResponsiveSearch = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // URL param se search term nikalna
  const urlSearch = searchParams.get("search") || "";

  // Local input state
  const [value, setValue] = useState(urlSearch);

  // Agar URL change ho (back button), toh input value sync karein smoothly
  useEffect(() => {
    setValue(urlSearch);
  }, [urlSearch]);

  // Form search handler memoized to avoid reconstruction on text keystrokes
  const handleSearch = useCallback(
    e => {
      if (e) e.preventDefault();
      const query = value.trim();
      if (query) {
        navigate(`/inquiries?search=${encodeURIComponent(query)}`);
      }
    },
    [value, navigate],
  );

  // Route clean handler memoized securely
  const handleClear = useCallback(() => {
    setValue("");
    navigate(`/inquiries`);
  }, [navigate]);

  // --- Icon Logic Optimized with useMemo ---
  // 1. Agar URL mein search active hai, toh hamesha CLOSE icon dikhao.
  // 2. Agar URL khali hai lekin user TYPE kar raha hai, toh SEARCH icon dikhao.
  const showCloseIcon = useMemo(() => urlSearch.length > 0, [urlSearch]);
  const showSearchIcon = useMemo(() => value.length > 0 && !showCloseIcon, [value, showCloseIcon]);

  return (
    <div className="search-box-wrapper mx-2">
      <Form
        className="app-search d-flex align-items-center"
        onSubmit={handleSearch}
        style={{ maxWidth: "300px" }}
      >
        <div className="position-relative w-100">
          <Input
            type="text"
            className="form-control rounded-pill bg-light border-0"
            placeholder="Search inquiries..."
            value={value}
            onChange={e => setValue(e.target.value)}
            style={{
              height: "38px",
              paddingLeft: "15px",
              paddingRight: "40px",
              fontSize: "13px",
            }}
          />

          <div
            className="position-absolute top-50 translate-middle-y"
            style={{ right: "12px", zIndex: 10 }}
          >
            {showCloseIcon ? (
              /* Close Icon: Jab search results dikh rahe hon */
              <span
                className="mdi mdi-close-circle text-danger fs-18"
                style={{ cursor: "pointer" }}
                onClick={handleClear}
              ></span>
            ) : showSearchIcon ? (
              /* Search Icon: Jab sirf typing ho rahi ho aur search baki ho */
              <span
                className="mdi mdi-magnify text-primary fs-18"
                style={{ cursor: "pointer" }}
                onClick={handleSearch}
              ></span>
            ) : null}
          </div>
        </div>
      </Form>
    </div>
  );
};

export default React.memo(ResponsiveSearch);
